import api from "../utils/api";
import {
    LOGOUT
} from "./types";
import { pack } from "./alert";

export const search = ({ page = 0, size = 10, order = "lastName", direction = "asc", search = null, assignment = "case", uuid=null }) => async (dispatch) => {
    try {
        const res = await api.get(`/cases/parties/p/${page}/s/${size}/o/${order}/${direction}/a/${assignment}/${uuid}/${search}`);
        return res.data;
    } catch (err) {
        console.log(err);
        //dispatch({ type: LOGOUT });
    }
}

export const save = (
    {
        uuid,
        caseUuid,
        personUuid,
        roles
    }) => async (dispatch) => {
        try {
            const res = await api.post(`/cases/parties`, {
                uuid,
                caseUuid,
                personUuid,
                roles
            });
            dispatch(pack(["Matter party saved"], "success"));
            return res.data;
        } catch (err) {
            dispatch({
                type: LOGOUT
            });
        }
    }

export const batch = (
    {
        caseUuid,
        items
    }) => async (dispatch) => {
        try {
            const res = await api.post(`/cases/parties/batch`, {
                caseUuid,
                items
            });
            dispatch(pack(["Matter party saved"], "success"));
            return res.data;
        } catch (err) {
            dispatch({
                type: LOGOUT
            });
        }
    }